import React, { memo, useEffect, useState } from 'react'
import {
  Accordion as AccordionMUI,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material'
import IconPasoInspeccion from 'components/icons/IconPasoInspeccion.svg'
import AddIcon from 'components/icons/IconPlus.svg'
import RemoveIcon from 'components/icons/IconMinus.svg'
import ArrowClose from 'components/icons/arrow_close.svg'
import sx from './styles'

const Accordion = (props) => {
  const {
    title,
    children,
    icon,
    isValid = false,
    expanded = false,
    setTitleBlackColor = false,
    IsValidIcon = null,
    arrowsIcon = false,
    sx: sxProp,
    className,
    firstIcon,
    forceOpen = false,
    id,
    showLastIcon = true,
  } = props
  const formTitleColor = setTitleBlackColor ? sx.formTitleValid : sx.formTitleInvalid
  const [isExpanded, setIsExpanded] = useState(expanded)
  const validIcon = IsValidIcon || <IconPasoInspeccion />

  useEffect(() => {
    if (expanded) {
      setIsExpanded((prev) => !prev)
    }
  }, [expanded])

  const onChangeExpanded = () => {
    setIsExpanded((prev) => !prev)
  }

  useEffect(() => {
    if (forceOpen === true) {
      setIsExpanded(true)
    }
  }, [forceOpen])

  return (
    <AccordionMUI
      mb={2}
      expanded={isExpanded}
      onChange={onChangeExpanded}
      sx={{ ...sx.root, ...sxProp }}
      className={className}
      id={id ? `${id}` : ''}
    >
      <AccordionSummary
        expandIcon={isExpanded ? (arrowsIcon ? <ArrowClose /> : <RemoveIcon />) : (arrowsIcon
          ? <ArrowClose /> : <AddIcon />)}
        aria-controls={title}
      >
        {
          firstIcon && (
            <Box
              sx={sx.firstIcon}
            >
              {firstIcon}
            </Box>
          )
        }

        <Box sx={sx.accordionContent}>
          <Typography
            variant="h4"
            component="p"
            sx={{ ...sx.formTitle, ...formTitleColor }}
          >
            {title}
          </Typography>
          {showLastIcon && (
            isValid ? validIcon : icon
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={sx.accordionDetails}>{children}</AccordionDetails>
    </AccordionMUI>
  )
}

export default memo(Accordion)
